import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Localization, LocalizationIdentity} from '../models/localization.model';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';
import {getHttpParams} from '../helpers/request.helper';

const LIST_ITEMS_LIMIT = 1000;

@Injectable()
export class LocalizationService {
    baseUrl = '/api/secured/localization';

    constructor(
        private http: HttpClient
    ) {}

    getUrl(partnerId: number, localizationId?: number) {
        return localizationId
            ? `${this.baseUrl}/${partnerId}/${localizationId}`
            : `${this.baseUrl}/${partnerId}`;
    }

    fetchList(partnerId: number, props: SearchQueryParams) {
        const url = partnerId ? `${this.baseUrl}/${partnerId}` : this.baseUrl;
        return this.http
            .get<Localization[]>(url, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Localization>(Localization));
    }

    fetchFilterList(partnerId) {
        const url = partnerId ? `${this.baseUrl}/${partnerId}/simple` : this.baseUrl;
        const params = getHttpParams({
            limit: LIST_ITEMS_LIMIT,
            orderByField: 'code',
            orderDirection: 'ASC'
        });
        return this.http.get<LocalizationIdentity[]>(url, {params})
            .pipe(
                catchError(() => {
                    return of(null);
                })
            );
    }

    fetchById(partnerId: number, localizationId: number) {
        return this.http.get<Localization>(this.getUrl(partnerId, localizationId));
    }

    activate(partnerId: number, localizationId: number) {
        return this.http.put(`${this.getUrl(partnerId, localizationId)}/activate`, {});
    }

    deactivate(partnerId: number, localizationId: number) {
        return this.http.put(`${this.getUrl(partnerId, localizationId)}/deactivate`, {});
    }

    add(partnerId: number, localization: Localization) {
        return this.http.post(this.getUrl(partnerId), {...localization});
    }

    update(localization: Localization) {
        return this.http.put(this.getUrl(localization?.partner?.id, localization.id), {...localization});
    }
}
